import googleMapOpts, { defaultRadius, mapRadiusZoomEnum } from './gmap.js'

export default {
    DEFAULT_MAP_OPT: googleMapOpts,
    ZOOM_RADIUS_ENUM: mapRadiusZoomEnum,
    DEFAULT_MAP_RADIUS: defaultRadius
}
